import * as React from "react";
import { Box, Card, CardContent, LinearProgress, Stack, Typography } from "@mui/material";

import { CampaignListHealth } from "@/hooks/api/use-campaigns";
import { CustomSkeleton } from "@/components/customSkeleton/custom-skeleton";

interface ListPenetrationCardProps {
	listHealth?: CampaignListHealth;
	isLoading?: boolean;
}

export function ListPenetrationCard({ listHealth, isLoading }: ListPenetrationCardProps): React.JSX.Element {
	const dialed = listHealth?.uniqueContactsDialed ?? 0;
	const total = listHealth?.contactsInList ?? 0;
	const undialed = listHealth?.undialedContacts ?? 0;
	const rate = listHealth?.listPenetrationRate ?? 0;

	return (
		<Card>
			<CardContent sx={{ p: 2, pb: "16px !important" }}>
				<Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1.5 }}>
					<Typography variant="subtitle1" fontWeight={600}>
						List penetration
					</Typography>
					{isLoading ? (
						<CustomSkeleton variant="text" width={120} height={20} />
					) : (
						<Typography variant="subtitle2" color="primary.main" fontWeight={600}>
							{dialed.toLocaleString()} / {total.toLocaleString()} ({rate}%)
						</Typography>
					)}
				</Stack>

				<LinearProgress
					variant={isLoading ? "indeterminate" : "determinate"}
					value={Math.min(rate, 100)}
					sx={{ height: 10, borderRadius: 5 }}
				/>

				<Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
					<Typography variant="caption" color="text.secondary">
						Unique contacts dialed
					</Typography>
					<Typography variant="caption" color="text.secondary">
						{undialed.toLocaleString()} undialed remaining
					</Typography>
				</Box>
			</CardContent>
		</Card>
	);
}
